import { render } from "./AgentePickJunta.vue?vue&type=template&id=f1a7a286"
import script from "./AgentePickJunta.vue?vue&type=script&lang=ts"
export * from "./AgentePickJunta.vue?vue&type=script&lang=ts"
script.render = render

export default script